import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from 'react-router-dom';
import { all_routes } from '../../../router/all_routes';

const Testimonials = () => {
    const route = all_routes
    return (
        <>
            {/* Testimonial */}
            <section className="testimonial-three">
                <div className="container">
                    <div className="testimonial-pattern">
                        <ImageWithBasePath
                            className="pattern-left img-fluid"
                            alt="Img"
                            src="assets/img/bg/pattern-05.svg"
                        />
                    </div>
                    <div className="testimonial-three-content">
                        <div className="row align-items-center row-gap-4">
                            <div className="col-xl-6 col-lg-12 col-md-12" data-aos="fade-down">
                                <div className="become-content">
                                    <h2 className="aos-init aos-animate">They Trusted us</h2>
                                    <h4 className="aos-init aos-animate">
                                        We are very happy because we have happy customers
                                    </h4>
                                </div>
                                {/* View all Testimonail */}
                                <Link
                                    to={route.register}
                                    className="btn btn-white aos-init aos-animate"
                                    data-aos="fade-up"
                                >
                                    Join Our Community
                                </Link>
                                {/* View all Testimonail */}
                            </div>
                            <div className="col-xl-6 col-lg-12 col-md-12" data-aos="fade-down">
                                <div className="swiper-testimonial-three">
                                    <Swiper effect="coverflow"
                                        loop={false}
                                        direction='horizontal'
                                        grabCursor={true}
                                        centeredSlides={true}
                                        slidesPerView="auto"
                                        initialSlide={2}
                                        speed={400}
                                        navigation={{
                                            prevEl: ".slide-prev-btn",
                                            nextEl: ".slide-next-btn",
                                        }}
                                        pagination={{ el: ".swiper-pagination", clickable: true }}
                                        coverflowEffect={{
                                            rotate: 0,
                                            stretch: 0,
                                            depth: 100,
                                            modifier: 10,
                                            slideShadows: true,
                                        }}
                                        modules={[EffectCoverflow, Navigation, Pagination]}
                                        className="swiper-wrapper">

                                        <SwiperSlide >
                                            <div className="swiper-slide">
                                                <div className="testimonial-item-five">
                                                    <div className="testimonial-quote">
                                                        <ImageWithBasePath
                                                            className="quote img-fluid"
                                                            alt="Img"
                                                            src="assets/img/bg/quote.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <p>
                                                            Finding the right program felt overwhelming until I found this platform. I knew I wanted to study business abroad, but choosing the right university was confusing. This service filled in all the gaps and guided me every step of the way.
                                                        </p>
                                                    </div>
                                                    <div className="testimonial-users">
                                                        <div className="imgbx">
                                                            <ImageWithBasePath
                                                                className="img-fluid"
                                                                alt="Img"
                                                                src="assets/img/user/user-01.jpg"
                                                            />
                                                        </div>
                                                        <div className="d-block">
                                                            <h6>— Emily R.</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>


                                        <SwiperSlide>
                                            <div className="swiper-slide">
                                                <div className="testimonial-item-five">
                                                    <div className="testimonial-quote">
                                                        <ImageWithBasePath
                                                            className="quote img-fluid"
                                                            alt="Img"
                                                            src="assets/img/bg/quote.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <p>
                                                            I was lost when it came to applying to universities overseas. The process seemed impossible to navigate. This platform made everything clear and simple, helping me find the perfect engineering program and submit my application with confidence.
                                                        </p>
                                                    </div>
                                                    <div className="testimonial-users">
                                                        <div className="imgbx">
                                                            <ImageWithBasePath
                                                                className=""
                                                                alt="Img"
                                                                src="assets/img/user/user-02.jpg"
                                                            />
                                                        </div>
                                                        <div className="d-block">
                                                            <h6>— Arjun S.</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>

                                        <SwiperSlide>
                                            {/* Swiper Slide */}
                                            <div className="swiper-slide">
                                                <div className="testimonial-item-five">
                                                    <div className="testimonial-quote">
                                                        <ImageWithBasePath
                                                            className="quote img-fluid"
                                                            alt="Img"
                                                            src="assets/img/bg/quote.svg"
                                                        />
                                                    </div>
                                                    <div className="testimonial-content">
                                                        <p>
                                                            Deciding on where to study medicine internationally was a huge challenge. I wasn’t sure about application requirements or deadlines. This platform filled all the gaps and gave me the support I needed to make the best choice.
                                                        </p>
                                                    </div>
                                                    <div className="testimonial-users">
                                                        <div className="imgbx">
                                                            <ImageWithBasePath
                                                                className=""
                                                                alt="Img"
                                                                src="assets/img/user/user-03.jpg"
                                                            />
                                                        </div>
                                                        <div className="d-block">
                                                            <h6>— Lina M.</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Swiper Slide */}
                                        </SwiperSlide>
                                    </Swiper>
                                    <div className="testimonial-bottom-nav">
                                        <div className="slide-next-btn testimonial-next-pre">
                                            <i className="fas fa-arrow-left" />
                                        </div>
                                        <div className="slide-prev-btn testimonial-next-pre">
                                            <i className="fas fa-arrow-right" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*/Testimonial */}
        </>

    )
}

export default Testimonials
